export const StoreCardSkeleton = () => {
  return (
    <div className="relative bg-white rounded-2xl border p-4 shadow-sm flex flex-col h-full animate-pulse">
      {/* Top Row */}
      <div className="flex items-start justify-between gap-3">
        <div className="flex items-start gap-3">
          <div className="w-4 h-4 bg-gray-200 rounded"></div>

          <div className="space-y-2">
            <div className="h-4 w-32 bg-gray-200 rounded"></div>
            <div className="h-3 w-20 bg-gray-200 rounded"></div>
          </div>
        </div>

        <div className="flex items-center gap-2">
          <div className="p-2 w-8 h-8 bg-gray-200 rounded-md"></div>
          <div className="p-2 w-8 h-8 bg-gray-200 rounded-md"></div>
        </div>
      </div>

      {/* Middle */}
      <div className="mt-4 flex-1 flex flex-col justify-between">
        <div className="space-y-4">
          <div className="h-3 w-20 bg-gray-200 rounded"></div>
          <div className="h-4 w-28 bg-gray-200 rounded"></div>

          <div className="grid grid-cols-2 gap-3 mt-3">
            <div className="space-y-2">
              <div className="h-3 w-16 bg-gray-200 rounded"></div>
              <div className="h-4 w-10 bg-gray-200 rounded"></div>
            </div>
            <div className="space-y-2">
              <div className="h-3 w-16 bg-gray-200 rounded"></div>
              <div className="h-4 w-10 bg-gray-200 rounded"></div>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="flex items-center justify-between text-xs mt-4">
          <div className="h-3 w-20 bg-gray-200 rounded"></div>
          <div className="h-3 w-20 bg-gray-200 rounded"></div>
        </div>
      </div>
    </div>
  );
};
